<template>
  <div class="index">
    <KHeader name="金蝶财务共享服务中心—路由页面(仅开发人员见)" :srcUrl="logoUrl"></KHeader>
    <p>访问路径后加以下对应的/xxx则访问对应页面</p>
    <div class="content">
      <p><router-link to="/moneyIn">收入收款 /moneyIn</router-link></p>
      <p><router-link to="/invoice">税票管理 /invoice</router-link></p>
      <p><router-link to="/costAll">费用总账 /costAll</router-link></p>
      <p><router-link to="/surveyAll">总体概况 /surveyAll</router-link></p>
      <p><router-link to="/staffPer">员工绩效 /staffPer</router-link></p>
    </div>
  </div>
</template>

<script>
const KHeader = resolve => require(['./common/KHeader.vue'], resolve)
export default {
  name: 'index',
  components: {
    KHeader
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  mounted () {
  },
  data () {
    return {
      logoUrl: require('../assets/img/logo.png')
    }
  }
}
</script>
<style scoped lang="scss">
.index{
  p{
    color: #333;
  }
  .content{
    >p{
      margin-top: 2rem;
      margin-right: 1rem;
      height: 1rem;
      &:hover{
        a{
          color: aquamarine;
        }
      }
    }
    a{
      color: white;
    }
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue